import React from "react";
import { Col, Row } from "react-bootstrap";
import { ClassificationIcon } from "../../../components";
import { YaraRevisionInfo } from "../@types";

interface IYaraHistoryItem {
  selectedRuleId: number;
  item: YaraRevisionInfo;
  onClick: (ruleId: number) => void;
}

const YaraHistoryItem = ({
  selectedRuleId,
  item: { value: ruleId, text, malicious, suspicious, goodware, unknown },
  onClick
}: IYaraHistoryItem) => (
  <Row className="o-rs-overlay-history__item">
    <Col
      xs={8}
      className={`o-rs-overlay-history__time ${
        selectedRuleId === ruleId ? "history-selected" : ""
      }`}
    >
      {text}
    </Col>
    <Col className={`${selectedRuleId === ruleId ? "history-selected" : ""}`}>
      <span className="threat-inline width-25-pc">
        <ClassificationIcon classification="malicious" />
        {malicious}
      </span>
      <span className="threat-inline width-25-pc">
        <ClassificationIcon classification="suspicious" />
        {suspicious}
      </span>
      <span className="threat-inline width-25-pc">
        <ClassificationIcon classification="goodware" />
        {goodware}
      </span>
      <span className="threat-inline width-25-pc">
        <ClassificationIcon classification="unknown" />
        {unknown}
      </span>
    </Col>
    <Col xs={1} className="c-sample-counts__status">
      <a style={{ cursor: "pointer" }} onClick={() => onClick(ruleId)}>
        Load
      </a>
    </Col>
  </Row>
);

export default YaraHistoryItem;
